// bookings/components/tabs/accessories/AccessoriesAvailablePanel.jsx
import React from "react";
import { Form } from "react-bootstrap";
import { useFormat } from "../../../../../components/FormatContext";
import { fromCents } from "../../../../../pages/bookings/utils/money";

/**
 * AccessoriesAvailablePanel (Accessories专用UI)
 * 依赖 accessories.css 的 acc-* 样式体系
 */
const AccessoriesAvailablePanel = ({
    customerCurrencyCode,
    rightAccessories = [],
    search = "",
    setSearch = () => { },
    toggleRight = () => { },
}) => {
    const { formatCurrency } = useFormat();
    return (
        <div className="acc-panel acc-available">
            {/* Header */}
            <div className="acc-panel__header">
                <h5 className="acc-panel__title">
                    <i className="bi bi-grid"></i>
                    <span>Available Accessories</span>
                </h5>

                <span className="acc-panel__count">{rightAccessories.length}</span>
            </div>

            {/* Scroll Area */}
            <div className="acc-panel__scroll">
                {/* Sticky search toolbar */}
                <div className="acc-available__toolbar acc-sticky">
                    <Form.Control
                        type="text"
                        placeholder="Search accessories..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                {/* List */}
                {rightAccessories.map((extra) => {
                    const name = extra?.name || "Accessory";
                    const description =
                        extra?.description || extra?.ShopExtra?.description || "";

                    const priceCents = extra?.totalWithFee ?? extra?.total ?? 0;

                    return (
                        <div
                            key={extra.id}
                            className="acc-available__row"
                            onClick={() => toggleRight(extra.id)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") toggleRight(extra.id);
                            }}
                        >
                            <div className="acc-available__check">
                                <Form.Check type="checkbox" checked={!!extra.isChecked} readOnly />
                            </div>

                            <div className="acc-available__main">
                                <div className="acc-available__top">
                                    <div className="acc-available__name" title={name}>
                                        {name}
                                    </div>

                                    <div className="acc-available__price text-success">
                                        {formatCurrency(fromCents(priceCents), customerCurrencyCode)}
                                    </div>
                                </div>

                                {description ? (
                                    <div className="acc-available__desc">{description}</div>
                                ) : (
                                    <div className="acc-available__desc text-muted">—</div>
                                )}

                                <div style={{ marginTop: 8 }}>
                                    <span
                                        className={`acc-badge ${extra.isChecked ? "acc-badge--on" : ""
                                            }`}
                                    >
                                        {extra.isChecked ? "Selected" : "Available"}
                                    </span>
                                </div>
                            </div>
                        </div>
                    );
                })}

                {/* Empty state */}
                {rightAccessories.length === 0 && (
                    <div className="text-center py-5 text-muted">
                        <i className="bi bi-exclamation-circle fs-1"></i>
                        <p className="mt-3 mb-0">No accessories found</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AccessoriesAvailablePanel;